























import Vue, { PropOptions } from "vue"
import { mapState, mapMutations, mapActions } from "vuex"

import ModalFooter from "~/components/shared/modal/footer.vue"
import ListElem from "~/components/shared/agency/favorites/elem.vue"

import eventMixin from "~/mixins/events"

import Bucket from "~/types/bucket"
import Influencer from "~/types/influencer"
interface PatchConfiguration {
  bucketId: number
  toggle: boolean
}

export default Vue.extend({
  components: {
    ModalFooter,
    ListElem,
  },
  mixins: [eventMixin],
  props: {
    influencer: {
      type: Object,
      required: true,
    } as PropOptions<Influencer>,
  },
  data() {
    return {
      patchOptions: [] as PatchConfiguration[],
    }
  },
  computed: {
    sortedBuckets(): Bucket[] {
      return [...this.BUCKETS].sort((memberA: Bucket, memberB: Bucket) => {
        return (
          new Date(memberA.datetime_updated).getTime() -
          new Date(memberB.datetime_updated).getTime()
        )
      })
    },
    ...mapState({
      BUCKETS: (state: any) => state.user.favorites.buckets,
    }),
  },
  methods: {
    buildNewPatchConfig(toggle: boolean, bucketId: number) {
      const modIndex: number = this.patchOptions.findIndex((patchOption) => {
        return patchOption.bucketId === bucketId
      })

      if (modIndex !== -1) this.patchOptions[modIndex] = { bucketId, toggle }
      else this.patchOptions.push({ bucketId, toggle })
    },
    async save() {
      await Promise.all(
        this.patchOptions.map((patchOption) => {
          const bucket: Bucket | undefined = this.BUCKETS.find(
            (bucket: Bucket) => bucket.id === patchOption.bucketId
          )

          if (bucket) {
            if (patchOption.toggle) this.addToBucket(bucket)
            else this.removeFromBucket(bucket)
            return this.PATCH_BUCKET(
              this.BUCKETS.find(
                (bucket: Bucket) => bucket.id === patchOption.bucketId
              )
            )
          }
        })
      )
      this.close()
    },
    close() {
      this.$set(this, "patchOptions", [])
      this.$emit("close")
      this.$parent.$emit("close")
    },
    addToBucket(bucket: Bucket) {
      //@ts-ignore
      this.trackEvent({
        category: "Bucket Management",
        action: "Add to bucket",
      })
      this.ADD_INF_FROM_BUCKET({
        influencerId: this.influencer.id,
        bucketId: bucket.id,
      })
    },
    removeFromBucket(bucket: Bucket) {
      //@ts-ignore
      this.trackEvent({
        category: "Bucket Management",
        action: "Remove from bucket",
      })
      this.REMOVE_INF_FROM_BUCKET({
        influencerId: this.influencer.id,
        bucketId: bucket.id,
      })
    },
    showCreate() {
      this.$emit("create")
    },
    ...mapActions({
      PATCH_BUCKET: "user/favorites/PATCH_BUCKET",
    }),
    ...mapMutations({
      ADD_INF_FROM_BUCKET: "user/favorites/ADD_INF_FROM_BUCKET",
      REMOVE_INF_FROM_BUCKET: "user/favorites/REMOVE_INF_FROM_BUCKET",
    }),
  },
})
